"use client";
import React, { useState } from "react";
import { usePathname } from "next/navigation";
import { getStrapiMedia } from "@aicodepro/web-builder-utils";

// Layout imports
import LayoutAbout1 from "./ContentLayouts/About/Layout1";
import Content_Home_Layout1 from "./ContentLayouts/Home/Layout1";
import Content_Home_Layout2 from "./ContentLayouts/Home/Layout2";
import Content_Home_Layout3 from "./ContentLayouts/Home/Layout3";
import Content_Home_Layout4 from "./ContentLayouts/Home/Layout4";
import Content_Home_Layout5 from "./ContentLayouts/Home/Layout5";

// Interfaces
interface ContentTextProps {
  title: string;
  text: string;
}

interface Button {
  id: string;
  url: string;
  text: string;
  type: string;
  newTab: boolean;
}

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}

interface ContentProps {
  data: {
    id: number;
    title: string;
    subtitle: string;
    picture: Picture;
    isReversed: boolean;
    contentTexts: ContentTextProps[];
    button: Button[];
    isLive: boolean;
    useH1Tag?: boolean;
    variant?: "home" | "patent";
    bgColor?: string;
  };
}

export default function Content({ data }: ContentProps) {
  const pathname = usePathname();
  const [selectedLayout, setSelectedLayout] = useState("layout1");
  const isHomePage = pathname === "/";
  const isInvention = pathname === "/invention";

  if (!data.isLive) return null;

  const renderHomeLayout = () => {
    switch (selectedLayout) {
      case "layout1":
        return <Content_Home_Layout1 data={data} />;
      case "layout2":
        return <Content_Home_Layout2 data={data} />;
      case "layout3":
        return <Content_Home_Layout3 data={data} />;
      case "layout4":
        return <Content_Home_Layout4 data={data} />;
      case "layout5":
        return <Content_Home_Layout5 data={data} />;
      default:
        return <Content_Home_Layout1 data={data} />;
    }
  };

  return (
    <>
      {isHomePage ? <Content_Home_Layout1 data={data} />
        : isInvention ? <LayoutAbout1 data={data} />
          : null
      }
    </>
  );
}
